import { render, staticRenderFns } from "./Exoplayer.vue?vue&type=template&id=6085ab94&scoped=true&"
import script from "./Exoplayer.vue?vue&type=script&lang=js&"
export * from "./Exoplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085ab94",
  null
  
)

export default component.exports